module.exports = __webpack_public_path__ + "static/media/message-bubble-right.72e7e727.svg";